// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"60cfd00b","213":"ffd0a01e","337":"6522b571","455":"65b218c9","457":"8984a491","730":"bdf35bdd","851":"ce06a38e"}[chunkId] + ".chunk.js";
};